import React, { Component, forwardRef, useEffect } from 'react'
import DocumentIcon from '../../assets/DocumentIcon.svg'


const RenderCurrentFolder = ({folderList, handleRightClickFolder, editMode, editInputRef, handleSaveEdit, getAllUploadedFiles, getAllSubDocuments, handleEditNameChange}) => {
    return (
      <>
        {folderList?.length > 0 &&
          folderList.map((folder, index) => (
            <div
              className="folder"
              key={index}
              onContextMenu={(event) => handleRightClickFolder(event, folder)}
              style={{ position: "relative" }}
            >
              <img
                src={DocumentIcon}
                alt="folder"
                className="folder-icon"
                onClick={(event) =>
                  folder?.documentTypeId
                    ? getAllUploadedFiles(folder, folderList)
                    : getAllSubDocuments(folder, folderList)
                }
              />
              {editMode.folder === folder ? (
                <input
                  ref={editInputRef}
                  type="text"
                  value={editMode.newName}
                  onChange={handleEditNameChange}
                  // onBlur={()=>editMode.newName.trim() === "" ?  editMode.folder.name : editMode.folder.name}
                  onKeyDown={(e) => {
                    if (e.key === "Enter")
                      handleSaveEdit(folder?.id, folder?.documentTypeId);
                  }}
                  onBlur={(e) => {
                      handleSaveEdit(folder?.id, folder?.documentTypeId);
                  }}
                  style={{
                    position: "absolute",
                    top: "65%",
                    left: 0,
                    width: "100%",
                    border: "1px solid #ccc",
                    padding: "1px",
                    boxSizing: "border-box",
                  }}
                />
              ) : (
                <p>{folder.name}</p>
              )}
            </div>
          ))}
      </>
    );
};

export default RenderCurrentFolder;